import { Form, Input } from "decorator-form";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as badgeDisplay from "../fragments/badge/displayFragments";

const badgeDisplayField = FragmentProvider.getLayoutInput(badgeDisplay);

@Form({title: "Badge List Config"})
export default class ProgramListConfig {

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize: number;

	@Input({type: badgeDisplayField, title: "Badge Layout"})
	public badgeLayout: ILayout<IFragmentLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/config/BadgeListPanelConfig.ts